import createActionTypes from './createActionTypes';

export const namespace = 'BRANDS';

export const types = createActionTypes(namespace, ['RESET']);

export const resetBrands = (resetState) => ({
  type: types.RESET,
  payload: { resetState },
});
